import RoleBasedLayout from "./RoleBasedLayout";
import HiringPage from "../ui/HiringPage";

export default function Hiring() {
    return (
        <RoleBasedLayout>
            <HiringPage />
        </RoleBasedLayout >
    );
}
